export default { sha: '7a2b3fb45ed7d6ae554ae38258788a420caf9c2f', buildNumber: 'undefined' }
